.toggle-switch-container {
  &.without-border {
    .toggle-switch {
      .react-switch-bg {
        border: none;
      }
      .react-switch-handle {
        box-shadow: none;
      }
    }
  }
  .toggle-switch {
    .react-switch-bg {
      opacity: 0.3;
      border: 1px solid rgba(0, 0, 0, 0.6);
      box-sizing: border-box;
    }
    .react-switch-handle {
      box-shadow: 0 0 2px 1px black;
    }

    &.recordings-switch-toggle {
      .react-switch-bg {
        opacity: 1;
      }
      .right-text {
        color: red !important;
      }

      .left-text,
      .right-text {
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 24px;
      }
      .react-switch-bg {
        border: none;
        cursor: pointer !important;
      }
      .react-switch-handle {
        box-shadow: none;
      }
    }
  }
}
